import React from "react";
import { MobileStepper, Button } from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import "./MobileSignUpStepper.css";

function MobileSignUpStepper(props) {
  const activeStep = props.stepperState.activeStep;
  return (
    <MobileStepper
      sx={{ backgroundColor: "#2B265A", color: "#ffffff" }}
      variant="dots"
      steps={3}
      activeStep={activeStep - 1}
      nextButton={
        <Button
          sx={{ color: "white" }}
          variant="text"
          size="large"
          disabled={activeStep === 3}
          onClick={props.handleNext}
        >
          Next
          <KeyboardArrowRight />
        </Button>
      }
      backButton={
        <Button
          size="large"
          sx={{ color: "white" }}
          variant="text"
          onClick={props.handleBack}
          disabled={activeStep === 1}
        >
          <KeyboardArrowLeft />
          Back
        </Button>
      }
    ></MobileStepper>
  );
}

export default MobileSignUpStepper;
